import gql from 'graphql-tag';

const MYSTAGE_AUTH_TOKEN = gql`
  mutation($credential: String!, $existingToken: String) {
    createAuthToken(credential: $credential, existingToken: $existingToken) {
      is_existing_valid
      mystage_token
      mystage_refresh_token
      mystage_service_id
      access_token_expires_at
      refresh_token_expires_at
      mystage_student_token
    }
  }
`;

const MYSTAGE_AUTH_REFRESH = gql`
  mutation {
    refreshAuthToken {
      mystage_token
      mystage_refresh_token
      mystage_service_id
      access_token_expires_at
      refresh_token_expires_at
      mystage_student_token
    }
  }
`;

export {
  MYSTAGE_AUTH_REFRESH,
  MYSTAGE_AUTH_TOKEN
};
